import { Link } from "react-router-dom";
import { HOME_FAQS } from "@/lib/site-seo";

export default function HomeFaq() {
  return (
    <section id="faq" className="relative border-t border-border">
      <div className="mx-auto max-w-4xl px-4 py-16 md:py-20">
        <p className="app-eyebrow mb-3">Questions & answers</p>
        <h2 className="heading-app mb-8 text-3xl text-foreground">Before you get started</h2>
        <dl className="divide-y divide-border">
          {HOME_FAQS.map(({ question, answer }) => (
            <div key={question} className="py-5">
              <dt className="text-lg font-semibold text-foreground">{question}</dt>
              <dd className="mt-2 leading-relaxed text-muted-foreground">{answer}</dd>
            </div>
          ))}
        </dl>
        <Link to="/pricing" className="text-accent-on-dark underline underline-offset-4">Compare the plans</Link>
      </div>
    </section>
  );
}